<template>
    <main class="user-profile-page">

        <!-- Theme Header -->
        <theme-header />

        <user-profileheader />

        <!-- User profile Content -->
        <user-profile-content />

        <!-- Theme Footer -->
        <theme-footer />

        <!-- Back To Top -->
        <back-to-top btnText="Back to top" :showIcon="true" />
        
    </main>
</template>


<script>
import ThemeFooter from '../components/common/ThemeFooter.vue'
import ThemeHeader from '../components/common/ThemeHeader.vue'
import BackToTop from '../components/pieces/BackToTop.vue'
import UserProfileContent from '../components/sections/UserProfileContent.vue'
import UserProfileheader from '../components/sections/UserProfileheader.vue'

export default {
    name: 'UserProfile',
    components: {
        ThemeHeader,
        ThemeFooter,
        BackToTop,
        UserProfileheader,
        UserProfileContent,
    },
    data() {
        return {
            
        }
    },
    methods: {
        
    }
}
</script>